import { Card } from '@/lib';
import { PerformanceAudienceChartMetric, PerformanceAudienceTrendSeries } from '@/services/endpoints/performanceAudience';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ChartMetricToggle } from '../ChartMetricToggle';
import { PlatformTrendChart } from '../PlatformTrendChart';

type PerformanceAudienceTrendSectionProps = {
  trend?: PerformanceAudienceTrendSeries;
  activeMetric: PerformanceAudienceChartMetric;
  onMetricChange: (metric: PerformanceAudienceChartMetric) => void;
};

export const PerformanceAudienceTrendSection: FC<PerformanceAudienceTrendSectionProps> = ({
  trend,
  activeMetric,
  onMetricChange,
}) => {
  const { t } = useTranslation('performanceAudience');
  const data = trend?.[activeMetric] ?? [];

  return (
    <Card className='flex h-full flex-col gap-6 border-primary-border bg-white p-6 drop-shadow-none'>
      <header className='flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between'>
        <div className='grid gap-0.5'>
          <h2 className='text-base font-semibold text-primary-900'>{t('trend.title')}</h2>
          <p className='text-sm text-tertiary-600'>{t('trend.subtitle')}</p>
        </div>
        <ChartMetricToggle activeMetric={activeMetric} onChange={onMetricChange} />
      </header>
      <PlatformTrendChart data={data} isPercentage={activeMetric === 'ctr'} />
    </Card>
  );
};
